import { createSlice } from '@reduxjs/toolkit'

export const clockDialogSlice = createSlice({
    name: 'clockDialog',
    initialState: {
        isOpen: false,
        status: '',
        shiftCollection: {},
        shiftRequest: { user: {} }
    },
    reducers: {
        openClockDialog: (state, action, status) => {
            // console.log('action pyaload')
            //console.log(action.payload)

            console.log('opening profile dialog in slice')
            state = {
                ...state,
                isOpen: true,
                shift: action.payload.shift ? action.payload.shift : null,
                shiftStatus: action.payload.shiftStatus,
                shiftRequest: action.payload.shiftRequest,
                shiftCollection: action.payload.shiftCollection
            }

            return state
        },
        updateShift: (state, action) => {
            state = {
                ...state,
                shift: action.payload
            }
            return state
        },
        closeClockDialog: (state, action) =>
            (state = { ...state, isOpen: false, status: '' })
    }
})

export const isOpen = state => state
export const {
    openClockDialog,
    closeClockDialog,
    updateShift
} = clockDialogSlice.actions

export default clockDialogSlice.reducer
